/* ARMORED SKIN — Shopify theme JS: cart AJAX, drawers, toasts, reveal */
(function () {
  "use strict";
  var AS = window.AS || { routes: { cartAdd: "/cart/add", cartChange: "/cart/change", cart: "/cart" }, moneyFormat: "{{amount_with_comma_separator}}€" };

  // ---------- money ----------
  function formatMoney(cents) {
    var v = (cents / 100).toFixed(2);
    var f = AS.moneyFormat || "{{amount_with_comma_separator}}€";
    if (f.indexOf("amount_with_comma_separator") !== -1) v = v.replace(".", ",");
    else if (f.indexOf("amount_no_decimals") !== -1) v = Math.round(cents / 100).toString();
    return f.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, v);
  }
  window.ASmoney = formatMoney;

  // ---------- toasts ----------
  var toastsEl = document.getElementById("toasts");
  function toast(title, sub) {
    if (!toastsEl) return;
    var t = document.createElement("div");
    t.className = "toast";
    t.innerHTML = '<span><svg class="ico ico-sm"><use href="#i-cart"/></svg></span><div><div class="mono">' + (sub || "Añadido") + "</div><div>" + title + "</div></div>";
    toastsEl.appendChild(t);
    setTimeout(function () { t.style.transition = "opacity .3s, transform .3s"; t.style.opacity = "0"; t.style.transform = "translateX(20px)"; }, 2400);
    setTimeout(function () { t.remove(); }, 2750);
  }
  window.AStoast = toast;
  window.addEventListener("as-toast", function (e) { toast(e.detail.title, e.detail.sub); });

  // ---------- cart drawer open/close ----------
  function overlay() { return document.getElementById("cartOverlay"); }
  function openCart() { var o = overlay(); if (o) { o.classList.add("open"); document.body.style.overflow = "hidden"; } }
  function closeCart() { var o = overlay(); if (o) { o.classList.remove("open"); document.body.style.overflow = ""; } }
  window.ASopenCart = openCart;

  // ---------- section re-render ----------
  function refreshCartDrawer(open) {
    return fetch(window.location.pathname + "?sections=cart-drawer")
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data["cart-drawer"];
        if (!html) return;
        var tmp = document.createElement("div");
        tmp.innerHTML = html;
        var fresh = tmp.querySelector("#cartOverlay");
        var cur = overlay();
        if (fresh && cur) {
          var wasOpen = cur.classList.contains("open");
          cur.replaceWith(fresh);
          if (wasOpen || open) { requestAnimationFrame(function () { openCart(); }); }
        }
        restorePromoState();
      })
      .then(updateCount);
  }
  window.ASrefreshCart = refreshCartDrawer;

  function updateCount() {
    return fetch("/cart.js").then(function (r) { return r.json(); }).then(function (cart) {
      var c = document.getElementById("cartCount");
      if (c) { c.textContent = cart.item_count; c.style.display = cart.item_count ? "" : "none"; }
      var t = document.getElementById("cartTitleCount");
      if (t) t.textContent = cart.item_count ? "(" + cart.item_count + ")" : "";
    });
  }

  // ---------- add to cart ----------
  function addVariant(variantId, qty, properties) {
    var body = { items: [{ id: parseInt(variantId, 10), quantity: qty || 1 }] };
    if (properties) body.items[0].properties = properties;
    return fetch(AS.routes.cartAdd + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || e.message || "Error"); });
      return r.json();
    });
  }
  window.ASaddVariant = addVariant;

  function changeLine(key, qty) {
    return fetch(AS.routes.cartChange + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  // ---------- promo (saved, applied at checkout via /discount/) ----------
  function restorePromoState() {
    var code = localStorage.getItem("as_promo_code");
    var st = document.getElementById("promoState");
    var applied = document.getElementById("promoApplied");
    if (st && code) { st.style.display = ""; if (applied) applied.textContent = code; }
  }
  function applyPromo(code) {
    localStorage.setItem("as_promo_code", code);
    // registers the discount cookie so checkout picks it up
    fetch("/discount/" + encodeURIComponent(code)).catch(function () {});
    restorePromoState();
    toast("Código guardado · se aplica en el checkout", code);
  }

  // ---------- delegated clicks ----------
  document.addEventListener("click", function (e) {
    var quick = e.target.closest(".js-quick-add");
    if (quick && !quick.disabled) {
      quick.classList.add("added");
      addVariant(quick.dataset.variantId, 1)
        .then(function () { toast(quick.dataset.name || "Producto", "Añadido al carrito"); return refreshCartDrawer(true); })
        .catch(function (err) { toast(err.message, "No se pudo añadir"); })
        .finally(function () { quick.classList.remove("added"); });
      e.preventDefault();
      return;
    }
    if (e.target.closest("#cartBtn")) { e.preventDefault(); openCart(); return; }
    if (e.target.closest("#cartClose") || e.target.closest("[data-cart-dismiss]")) { closeCart(); return; }

    var lineBtn = e.target.closest(".qty-btn[data-act], .ci-del[data-act]");
    if (lineBtn) {
      var ci = lineBtn.closest(".ci");
      if (ci && ci.dataset.lineKey) {
        var qtyEl = ci.querySelector(".qty-n");
        var q = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
        var act = lineBtn.dataset.act;
        var newQ = act === "inc" ? q + 1 : act === "dec" ? q - 1 : 0;
        ci.style.opacity = ".5";
        changeLine(ci.dataset.lineKey, Math.max(0, newQ)).then(function () {
          if (document.body.contains(overlay()) && overlay().contains(ci)) refreshCartDrawer(false);
          else window.location.reload();
        });
        e.preventDefault();
        return;
      }
    }
    if (e.target.closest("#removePromo")) {
      localStorage.removeItem("as_promo_code");
      var st = document.getElementById("promoState");
      if (st) st.style.display = "none";
      return;
    }
  });

  // promo form (delegated submit — drawer re-renders)
  document.addEventListener("submit", function (e) {
    if (e.target && e.target.id === "promoForm") {
      e.preventDefault();
      var inp = document.getElementById("promoInput");
      var val = (inp.value || "").trim().toUpperCase();
      if (val) { applyPromo(val); inp.value = ""; }
    }
    // product page form via AJAX
    if (e.target && e.target.id === "pdpForm") {
      e.preventDefault();
      var form = e.target;
      var fd = new FormData(form);
      fetch(AS.routes.cartAdd + ".js", { method: "POST", body: fd, headers: { "Accept": "application/json" } })
        .then(function (r) { if (!r.ok) return r.json().then(function (x) { throw new Error(x.description || "Error"); }); return r.json(); })
        .then(function () { toast(document.querySelector(".pdp-title") ? document.querySelector(".pdp-title").textContent : "Producto", "Añadido al carrito"); return refreshCartDrawer(true); })
        .catch(function (err) { toast(err.message, "No se pudo añadir"); });
    }
  });

  // ---------- mobile drawer ----------
  var drawer = document.getElementById("drawer");
  var menuBtn = document.getElementById("menuBtn");
  var drawerClose = document.getElementById("drawerClose");
  function closeDrawer() { if (drawer) drawer.classList.remove("open"); }
  if (menuBtn) menuBtn.addEventListener("click", function () { drawer.classList.add("open"); });
  if (drawerClose) drawerClose.addEventListener("click", closeDrawer);
  if (drawer) {
    drawer.addEventListener("click", function (e) { if (e.target === drawer) closeDrawer(); });
    drawer.querySelectorAll("a").forEach(function (a) { a.addEventListener("click", closeDrawer); });
  }

  // ---------- product page: variant picker ----------
  var pdpData = document.getElementById("pdpData");
  if (pdpData) {
    try {
      var P = JSON.parse(pdpData.textContent);
      var opts = document.querySelectorAll(".pdp-opt");
      function selectedValues() {
        var vals = [];
        opts.forEach(function (o) {
          var a = o.querySelector(".pdp-opt-btn.active");
          vals[parseInt(o.dataset.optionIndex, 10)] = a ? a.dataset.value : null;
        });
        return vals;
      }
      function syncVariant() {
        var vals = selectedValues();
        var match = P.variants.find(function (v) {
          var vo = v.options || [v.option1, v.option2, v.option3];
          return vo.every(function (ov, i) { return vals[i] === null || vals[i] === undefined || ov === vals[i]; });
        });
        var idEl = document.getElementById("pdpVariantId");
        var addBtn = document.getElementById("pdpAdd");
        var priceEl = document.getElementById("pdpPrice");
        var wasEl = document.getElementById("pdpWas");
        if (match) {
          idEl.value = match.id;
          priceEl.textContent = formatMoney(match.price);
          if (match.compare_at_price && match.compare_at_price > match.price) { wasEl.textContent = formatMoney(match.compare_at_price); wasEl.style.display = ""; }
          else wasEl.style.display = "none";
          addBtn.disabled = !match.available;
          addBtn.firstChild.textContent = match.available ? "Añadir al carrito " : "Agotado ";
          if (match.featured_image && match.featured_image.src) {
            var main = document.getElementById("pdpMain");
            if (main) main.src = match.featured_image.src;
          }
        } else {
          addBtn.disabled = true;
          addBtn.firstChild.textContent = "No disponible ";
        }
      }
      opts.forEach(function (o) {
        o.addEventListener("click", function (e) {
          var b = e.target.closest(".pdp-opt-btn");
          if (!b) return;
          o.querySelectorAll(".pdp-opt-btn").forEach(function (x) { x.classList.remove("active"); });
          b.classList.add("active");
          syncVariant();
        });
      });
      document.querySelectorAll("[data-pdp-qty]").forEach(function (b) {
        b.addEventListener("click", function () {
          var q = document.getElementById("pdpQty");
          q.value = Math.max(1, (parseInt(q.value, 10) || 1) + parseInt(b.dataset.pdpQty, 10));
        });
      });
      document.querySelectorAll(".pdp-thumb").forEach(function (t) {
        t.addEventListener("click", function () { document.getElementById("pdpMain").src = t.dataset.src; });
      });
      if (opts.length) syncVariant();
    } catch (err) { /* noop */ }
  }

  // ---------- reveal on scroll ----------
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    document.querySelectorAll(".reveal").forEach(function (el) { io.observe(el); });
    setTimeout(function () { document.querySelectorAll(".reveal:not(.in)").forEach(function (el) { el.classList.add("in"); }); }, 1800);
  } else {
    document.querySelectorAll(".reveal").forEach(function (el) { el.classList.add("in"); });
  }

  // ---------- tarjeta regalo (delegado: sobrevive a re-renders del editor) ----------
  document.addEventListener("click", function (e) {
    var chip = e.target.closest(".gc-chip");
    if (chip && !chip.disabled) {
      var box = chip.closest(".gift-amounts");
      if (box) {
        box.querySelectorAll(".gc-chip").forEach(function (c) { c.classList.remove("active"); c.setAttribute("aria-checked", "false"); });
        chip.classList.add("active");
        chip.setAttribute("aria-checked", "true");
      }
      return;
    }
    var buy = e.target.closest("#gcBuy");
    if (buy) {
      var section = buy.closest("section") || document;
      var sel = section.querySelector(".gc-chip.active");
      if (!sel || !sel.dataset.variantId) { toast("Elige un importe", "Tarjeta regalo"); return; }
      buy.disabled = true;
      addVariant(sel.dataset.variantId, 1)
        .then(function () {
          toast((buy.dataset.name || "Tarjeta regalo") + " · " + sel.textContent.trim(), "Añadido al carrito");
          return refreshCartDrawer(true);
        })
        .catch(function (err) { toast(err.message, "No se pudo añadir"); })
        .finally(function () { buy.disabled = false; });
    }
  });

  // ---------- editor de temas: al re-renderizar una sección, forzar visibilidad de .reveal ----------
  document.addEventListener("shopify:section:load", function (e) {
    e.target.querySelectorAll(".reveal").forEach(function (el) { el.classList.add("in"); });
  });

  restorePromoState();
})();
